// Resolve backend URL at runtime so the frontend works in both PREVIEW and PRODUCTION
// even though REACT_APP_BACKEND_URL is baked at build time.
const BUILD_TIME_API_URL = process.env.REACT_APP_BACKEND_URL || '';

export function getApiUrl() {
  if (typeof window === 'undefined') return BUILD_TIME_API_URL;
  const host = window.location.hostname;
  // On production domain, use same-origin (relative URL).
  if (host === 'notariapublica90.com' || host.endsWith('.notariapublica90.com')) {
    return '';
  }
  return BUILD_TIME_API_URL;
}

export const API_URL = getApiUrl();
